import axiosClient from "utils";

async function fetchMessages(params) {
  const url = `/v1/notify`;
  return axiosClient.get(url, { params });
}

export { fetchMessages };
